import { SubmitFeedbackInput, SubmitFeedbackResponse } from "@examspark/types";

import { GraphQLAPI } from "../client";
import * as feedback from "../queries/feedback";

export const submitFeedback = async (request: SubmitFeedbackInput) =>
  GraphQLAPI.query<{
    submitFeedback: SubmitFeedbackResponse;
  }>({
    query: feedback.submitFeedback(),
    variables: {
      input: request,
    },
  });
